'use strict';

var merge = require('merge');

module.exports = function (defaults, globalOptions, localOptions) {

  if (globalOptions) defaults = merge.recursive(defaults, globalOptions);

  localOptions = merge.recursive(defaults, localOptions);

  return localOptions;
};


// WEBPACK FOOTER //
// ./src/components/vuetable-2-kernel/compiled/methods/init-options.js